<aside grooveCallout [tone]="variant()" class="callout">
  <h3 class="callout-heading">{{ heading() }}</h3>
  <div class="callout-body">
    <ng-content />
  </div>
</aside>
